import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses } from '../../lib/ep';

const ProgressBar = (props) => {
	const max = props?.max ?? 100;
	const actual = props?.actual ?? 0;

	const progress = (actual > 0) ? Math.min(100, Math.ceil(100 * actual / max)) : 0;
	const display_percent = props?.display_percent ?? true;
	const display_percent_in_bar = props?.display_percent_in_bar ?? true;

	const icon = props?.icon ?? false;
	const progress_label = props?.progress_label ?? `${progress}%`;
	const duration = props?.animation_duration ?? '2s';

	const classes = ['gui_progress'];
	if(props.floating != undefined && props.floating) {
		classes.push('is_floating');
		if(props._position != undefined) classes.push(`is_${props._position}`);
	}
	const classname = parseClasses(classes.join(" "), props._class, 'progress');

	const extra_class = ['bar_guide', 'gui_is_animated'];
	if(progress == 100) extra_class.push('is_completed');
	if(props.size != undefined) extra_class.push(props.size);

	const bar_class = ['bar'];
	if(props.color != undefined) bar_class.push(props.color);
	if(props.classes != undefined) bar_class.push(props.classes);

	const bar_styles = {
		width:`${progress}%`,
		'--transition-duration':duration,
	};
	if(props.initial_width != undefined) {
		bar_styles['--initial-width-state'] = props.initial_width;
	}

	let label = false;
	if(props.children) {
		const autotranslate = props?.autotranslate ?? true;
		const _label = (autotranslate) ? props.intl.formatMessage({id:props.children}) : props.children;
		label = (typeof(_label) == 'string') ? _label.replace("***", "") : _label;
	}

	useEffect(() => {
		if(props.onEnd == undefined) return;

		const duration_int = parseInt(duration);

		setTimeout(() => {
			props.onEnd();
		}, duration_int * 1000);
	}, []);

	return (
		<div class={classname} style={props.style}>
			{(icon) && (
				<div class={`progress_icon gui_small_icon ${icon}`} />
			)}

			<div class={extra_class.join(" ")}>
				<div
					class={bar_class.join(" ")}
					style={bar_styles}
				>
					{(display_percent_in_bar) && (
						<span>{progress_label}</span>
					)}
				</div>

				{(props.reinforcement_color != undefined) && (
					<div
						class={`bar_reinforcement ${bar_class.join(" ")}`}
						style={{
							...bar_styles,
							opacity:(100 - progress) / 100,
							'--main-color':props.reinforcement_color,
						}}
					/>
				)}
			</div>

			{(label) && (
				<div class="progress_num">
					{label}

					{(display_percent) && (
						<span> ({progress}%)</span>
					)}
				</div>
			)}

			{(!label && display_percent) && (
				<div class="progress_num only_number">{progress}%</div>
			)}

			{(props.extra_contents != undefined) && (
				props.extra_contents
			)}
		</div>
	)
};

export default injectIntl(ProgressBar);